import {
  Glass,
  PillChip,
  Dot,
  ScreenLabel,
  DisplayText,
  BodyText,
  alpha,
} from "../../components/mobile/primitives";

export const VAULT_FILES = [
  {
    dot: "var(--color-kin-green-soft)",
    title: "Blood panel Feb 2026",
    sub: "Lab report \u00b7 Feb 12",
  },
  { dot: "var(--color-kin-lavender)", title: "Oura Sleep Export", sub: "Wearable \u00b7 Feb 28" },
  { dot: "var(--color-kin-gold)", title: "Nutrition Log Feb", sub: "Note \u00b7 Feb 25" },
  { dot: "var(--color-kin-rose)", title: "Chest X-Ray 2025", sub: "Imaging \u00b7 Dec 14" },
  {
    dot: "var(--color-kin-gold-dark)",
    title: "Vitamin D Prescription",
    sub: "Prescription \u00b7 Jan 9",
  },
];

export function VaultScreen() {
  return (
    <div style={{ padding: "8px 16px 0", display: "flex", flexDirection: "column", gap: 14 }}>
      {/* Header */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingLeft: 4,
        }}
      >
        <DisplayText size={28} color="var(--color-kin-black)" lineHeight={1.1}>
          Vault
        </DisplayText>
        <div
          style={{
            width: 36,
            height: 36,
            borderRadius: "50%",
            background: "rgba(254,253,251,0.8)",
            border: "1px solid rgba(255,255,255,0.9)",
            boxShadow: "0 4px 12px -4px rgba(0,0,0,0.06), inset 0 1px 0 rgba(255,255,255,0.8)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backdropFilter: "blur(12px)",
          }}
        >
          <span
            style={{
              color: "var(--color-kin-black)",
              fontSize: 24,
              fontWeight: 300,
              lineHeight: 1,
              marginTop: -2,
            }}
          >
            +
          </span>
        </div>
      </div>

      {/* Vault stats */}
      <Glass style={{ overflow: "hidden", borderRadius: 24, paddingBottom: 6 }}>
        <div style={{ display: "flex", justifyContent: "space-around", padding: "14px 10px 10px" }}>
          {[
            ["12", "Sources"],
            ["9", "Indexed"],
            ["3", "Integrations"],
          ].map(([v, l]) => (
            <div
              key={l}
              style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 4 }}
            >
              <DisplayText size={26} color="var(--color-kin-black)">
                {v}
              </DisplayText>
              <ScreenLabel style={{ letterSpacing: "0.15em" }}>{l}</ScreenLabel>
            </div>
          ))}
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: 8,
            padding: "8px 16px 8px",
            borderTop: "1px solid rgba(0,0,0,0.04)",
          }}
        >
          <Dot
            color="var(--color-kin-green-soft)"
            size={8}
            style={{ boxShadow: `0 0 6px ${alpha("var(--color-kin-green-soft)", "80")}` }}
          />
          <BodyText size={10} color="var(--color-kin-muted)" weight={600}>
            12 sources · 9 indexed
          </BodyText>
        </div>
      </Glass>

      {/* Search */}
      <Glass
        style={{
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: 10,
          borderRadius: 24,
        }}
      >
        <span style={{ color: "var(--color-kin-muted)", fontSize: 16 }}>⌕</span>
        <BodyText size={11} color="var(--color-kin-muted)" weight={600}>
          Search your vault…
        </BodyText>
      </Glass>

      {/* Category chips */}
      <div
        className="phone-scroll"
        style={{ display: "flex", gap: 6, overflowX: "auto", paddingLeft: 4, paddingBottom: 4 }}
      >
        {[
          ["All \u00b7 12", true],
          ["Lab \u00b7 4", false],
          ["Wearable \u00b7 3", false],
          ["Nutrition \u00b7 3", false],
          ["Notes \u00b7 2", false],
        ].map(([lbl, active]) => (
          <PillChip key={lbl} active={active} color="var(--color-kin-green-soft)">
            {lbl}
          </PillChip>
        ))}
      </div>

      {/* File list */}
      <Glass style={{ padding: "6px 16px", borderRadius: 24 }}>
        {VAULT_FILES.map((file, i) => (
          <div
            key={i}
            style={{
              display: "flex",
              alignItems: "center",
              gap: 12,
              padding: "12px 0",
              borderBottom: i < VAULT_FILES.length - 1 ? "1px solid rgba(0,0,0,0.04)" : "none",
            }}
          >
            <Dot
              color={file.dot}
              size={8}
              style={{ boxShadow: `0 0 6px ${alpha(file.dot, "60")}` }}
            />
            <div style={{ flex: 1, minWidth: 0 }}>
              <BodyText size={12} color="var(--color-kin-black)" weight={600}>
                <span
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    display: "block",
                  }}
                >
                  {file.title}
                </span>
              </BodyText>
              <BodyText
                size={9}
                color="var(--color-kin-muted)"
                weight={500}
                style={{ marginTop: 2 }}
              >
                {file.sub}
              </BodyText>
            </div>
            <span
              style={{
                color: "var(--color-kin-olive-light)",
                fontSize: 18,
                flexShrink: 0,
                fontWeight: 300,
              }}
            >
              ›
            </span>
          </div>
        ))}
      </Glass>

      {/* Hint row */}
      <div
        style={{
          background: "rgba(91,122,102,0.1)",
          border: "1px solid rgba(91,122,102,0.25)",
          borderRadius: 20,
          padding: "12px 16px",
          display: "flex",
          alignItems: "center",
          gap: 10,
          boxShadow: "0 4px 12px -4px rgba(91,122,102,0.1)",
        }}
      >
        <span
          style={{
            color: "var(--color-kin-green-soft)",
            fontSize: 16,
            flexShrink: 0,
            fontWeight: 700,
          }}
        >
          +
        </span>
        <BodyText size={10} color="#3e5746" weight={800}>
          Add more data — your data, your vault
        </BodyText>
      </div>
    </div>
  );
}
